document.addEventListener("DOMContentLoaded", function () {
  const checkPhotoSwipe = setInterval(() => {
    const pswpEl = document.querySelector(".pswp");

    if (pswpEl && window.PhotoSwipe) {
      clearInterval(checkPhotoSwipe);

      // Override PhotoSwipe UI behavior
      const originalInit = window.PhotoSwipeUI_Default.prototype.init;
      window.PhotoSwipeUI_Default.prototype.init = function () {
        originalInit.apply(this, arguments);

        // Disable zoom interactions
        this.pswp.options.zoomEl = false;
        this.pswp.options.pinchToClose = true;
        this.pswp.options.clickToCloseNonZoomable = true;
        this.pswp.options.tapToClose = true;
        this.pswp.options.tapToToggleControls = false;

        // Listen for any click/tap inside PhotoSwipe image area
        this.pswp.template.addEventListener("click", (e) => {
          e.preventDefault();
          if (this.pswp && this.pswp.isOpen) {
            this.pswp.close();
          }
        });
      };

      console.log("✅ PhotoSwipe now exits on click (no zoom)");
    }
  }, 300);
});
